import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
  query bondTypesActive($name: String, $code: String, $is_massive: Boolean) {
    bondTypesActive(name: $name, code: $code, is_massive: $is_massive) {
      id
      name
      code
      is_active
      is_massive
      amount_fortnight
      status_text
    }
  }
`
const GET_WITH_PAGINATION = gql`
  query bondTypesWithPagination ($page: Int, $perPage: Int) {
    bondTypesWithPagination (page: $page, first: $perPage) {
      paginatorInfo {
        currentPage
        count
        hasMorePages
        perPage
        total
      }
      data {
        id
        name
        code
        is_active
        is_massive
        amount_fortnight
        status_text
      }
    }
  }
`
/**
 * Mutations
 */
const CREATE = gql`
  mutation createBondType ($input: BondTypeInput!) {
    createBondType (input: $input) {
      id
      name
      code
      is_active
      status_text
    }
  }
`

const UPDATE = gql`
  mutation updateBondType ($id: ID!, $input: BondTypeInput!) {
    updateBondType (id: $id, input: $input) {
      id
      name
      code
      is_active
      status_text
    }
  }
`

const DELETE = gql`
  mutation deleteBondType ($id: ID!) {
    deleteBondType (id: $id) {
      id
      name
      code
      is_active
      status_text
    }
  }
`

export {
  ALL_ACTIVE,
  GET_WITH_PAGINATION,
  CREATE,
  UPDATE,
  DELETE
}
